'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _FileCopy = _interopRequireDefault(require("@material-ui/icons/FileCopy"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _DeleteCompanyModal = _interopRequireDefault(require("Modals/DeleteCompanyModal"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
const sectors_default_options = [{
  value: 'all',
  label: 'Tous les secteurs'
}];
const sector_activities_default_options = [{
  value: 'all',
  label: 'Tous'
}];
class Companies extends _react.Component {
  state = {
    selected: [],
    companies: [],
    companies_count: 0,
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    openSnackBar: false,
    searched_company_name: '',
    sector_activity_filter: 'all',
    openDeleteCompanyModal: false,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.session?.user?.id) {
      component.setSectorInState();
    }
    app.push({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
    component.fetchSectorActivity();
    component.fetchSectors();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
  }
  fetchCompanies = ({
    page,
    order,
    order_by,
    sectors_filter,
    searched_company_name,
    sector_activity_filter
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      order: order,
      order_by: order_by,
      sector_activity_filter: sector_activity_filter || state.sector_activity_filter,
      sectors_filter: sectors_filter || state.sectors_filter,
      searched_company_name: searched_company_name || state.searched_company_name
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        companies: response.companies,
        companies_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchSectors = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all').then(function (xhr, response) {
      component.setState({
        sectors: response.sectors,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchSectorActivity = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        sector_activities: response.company_activities
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeleteCompanyModal = ({
    company_id,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteCompanyModal: true,
      delete_modal_company: company_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteCompanyModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteCompanyModal: false,
      delete_modal_company: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchCompanies({});
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchCompanies({
      page: page
    });
  };
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (e === null) return;
    component.setState({
      [name]: value
    });
    component.fetchCompanies({
      [name]: value
    });
  };
  handleRequestSort = (e, column) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = column.id;
    let order = 'desc';
    if (state.order_by === order_by && state.order === 'desc') {
      order = 'asc';
    }
    component.setState({
      order: order,
      order_by: order_by,
      loading: true
    });
    component.fetchCompanies({
      order: order,
      order_by: order_by
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_company_name: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchCompanies({
        searched_company_name: value
      });
    }, 800);
  };
  handleCloseSnackBar = (event, reason) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (reason === 'clickaway') {
      return;
    }
    component.setState({
      openSnackBar: false
    });
  };
  handleCopy = email => {
    const component = this,
      props = this.props,
      state = this.state;
    navigator.clipboard.writeText(email);
    component.setState({
      openSnackBar: true
    });
  };
  setSectorInState = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const user_sector = app.state.session?.user?.sector;
    const user_roles = app.state.session?.user?.roles;
    if (user_roles.includes('admin') || user_roles.includes('super_admin') || user_roles.includes('accompanist')) {
      component.setState({
        sectors_filter: 'all'
      });
      component.fetchCompanies({
        sectors_filter: 'all'
      });
    } else {
      component.setState({
        sectors_filter: user_sector || 'all'
      });
      component.fetchCompanies({
        sectors_filter: user_sector || 'all'
      });
    }
  };
  getSectorActivityLabel = sector_activity_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.sector_activities) return;
    let sector_activity = state.sector_activities.find(sector_activity => sector_activity.id === sector_activity_id);
    return sector_activity?.label;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user_roles = app.state.session?.user?.roles;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.companies_count - state.page * state.rows_per_page);
    _moment.default.locale('fr');
    const rows = (state.companies || []).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/liste-des-entreprises/' + data.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.company_name, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.lastname + ' ' + data.firstname, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.home_phone_number, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.phone_number, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.login, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.handleCopy(data.login)
      }, /*#__PURE__*/_react.default.createElement(_FileCopy.default, {
        color: "secondary"
      }))), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getSectorActivityLabel(data.company_activity)), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeleteCompanyModal({
          company_id: data.id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      })) : undefined));
      return output;
    });
    const columns = [{
      id: 'company_name',
      sortable: false,
      numeric: false,
      label: 'Nom de l\'entreprise',
      center: true
    }, {
      id: 'lastname',
      sortable: false,
      numeric: false,
      label: 'Nom de la personne en charge',
      center: true
    }, {
      id: 'home_phone_number',
      sortable: false,
      numeric: false,
      label: 'Téléphone fixe',
      center: true
    }, {
      id: 'phone_number',
      sortable: false,
      numeric: false,
      label: 'Téléphone portable',
      center: true
    }, {
      id: 'login',
      sortable: false,
      numeric: false,
      label: 'E-mail',
      center: true
    }, {
      id: 'company_activity',
      sortable: false,
      numeric: false,
      label: 'Secteur d\'activité',
      center: true
    }, {
      id: 'actions',
      sortable: false,
      numeric: false,
      label: '',
      center: true
    }];
    const sector_options = (state.sectors || []).map(function (sector) {
      let option = {
        label: sector.name,
        value: sector.id
      };
      return option;
    });
    let sector_activities_options = (state.sector_activities || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (sector_activity) {
      let option = {
        label: sector_activity.label,
        value: sector_activity.id
      };
      return option;
    });
    const filter = state.sectors ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.sectors_filter,
      className: "u-padding-10",
      name: "sectors_filter",
      status: state.status_messages,
      options: sectors_default_options.concat(sector_options),
      "default-value": sectors_default_options[0].value,
      label: "Secteur AEAA"
    }) : undefined;
    const sector_activities_filter = state.sector_activities ? /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleFilterChange,
      value: state.sector_activity_filter,
      className: "u-padding-10",
      name: "sector_activity_filter",
      status: state.status_messages,
      options: sector_activities_default_options.concat(sector_activities_options),
      "default-value": sector_activities_default_options[0].value,
      label: "Secteur d'activit\xE9"
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-filter"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "u-padding-10 u-full-width",
      name: "searched_company_name",
      label: "Recherche par nom",
      status: state.status_messages,
      value: state.searched_company_name
    }), user_roles.includes('admin') ? filter : undefined, sector_activities_filter), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Candidats"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: rows.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.companies_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: ({
        from,
        to,
        count
      }) => from + '-' + to + ' sur ' + count
    }), user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      href: "/telechargements/entreprises",
      size: "large",
      className: "custom-export-button",
      target: "_blank",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Exporter toutes les entreprises xls") : undefined, user_roles.includes('admin') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      href: "/telechargements/entreprises?sector_filter=" + (state.sectors_filter || "all") + '&sector_activity_filter=' + (state.sector_activity_filter || "all"),
      size: "large",
      className: "custom-export-button",
      target: "_blank",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Exporter les entreprises avec les filtres en xls") : undefined, /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
      open: state.openSnackBar,
      autoHideDuration: 1500,
      onClose: component.handleCloseSnackBar
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-snackbar"
    }, "Email copi\xE9")), /*#__PURE__*/_react.default.createElement(_DeleteCompanyModal.default, {
      company_to_delete: state.delete_modal_company,
      open: state.openDeleteCompanyModal,
      onClose: component.closeDeleteCompanyModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = Companies;
